import * as React from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Logo from '../assets/logo-sebrae.png';
import LogoRight from '../assets/logo-sebrae-one.svg';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, createSearchParams } from 'react-router-dom';
import InputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from 'react-hook-form';
import CustomizedDialogs from '../components/ModalAlert';
import { handleHttpError } from '../utils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuralAvisos from '../components/MuralAvisos';

export const RecuperarSenhaPage = () => {
  const { recuperarSenha } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [cpf, setCpf] = React.useState('');
  const [cnpj, setCnpj] = React.useState('');
  const navigate = useNavigate();
  const { handleSubmit, control } = useForm();
  const [radioValue, setRadioValue] = React.useState('PJ');

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setCnpj(data.cnpj.replace(/[^a-zA-Z0-9]/g, ''));
      setCpf(data.cpf.replace(/\D/g, ''));
      const result = await recuperarSenha({
        cnpj:
          radioValue == 'PJ'
            ? data.cnpj.replace(/[^a-zA-Z0-9]/g, '')
            : data.cpf.replace(/\D/g, ''),
        cpf: data.cpf.replace(/\D/g, ''),
      });

      setMessage(result.data.message);
      setType('success');
      setVisible(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMessage(
        `${handleHttpError(error)} Entre em contato no telefone: ${
          process.env.REACT_APP_TELEFONE_SUPORTE
        }`,
      );
      setType('error');
      setVisible(true);
    }
  };

  const goToLogin = () => {
    navigate({
      pathname: '/',
      search: `?${createSearchParams({
        cpf: cpf,
        cnpj: cnpj,
      })}`,
    });
  };

  const changeTipo = (event) => {
    setRadioValue(event);
  };

  return (
    <Grid container spacing={0}>
      <MuralAvisos />
      <Grid item sm={4}>
        <CustomizedDialogs
          content={message}
          btnTxt={type === 'success' ? 'Ir para login' : 'Ok'}
          type={type}
          onClick={goToLogin}
          handleClose={setVisible}
          visible={visible}
        />
        <img src={Logo} />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            align="left"
            color={'#00669e'}
            style={{ width: '60%', fontSize: 16 }}
          >
            Para recuperar sua senha preencha os campos a baixo. Enviaremos um
            e-mail para o endereço cadastrado para que possa redefini-la.
          </Typography>
          <Box style={{ width: '60%' }} sx={{ mt: 1 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <RadioGroup
                row
                value={radioValue}
                style={{ width: '100%' }}
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={(e) => {
                  changeTipo(e.target.value);
                }}
              >
                <Grid container spacing={2} margin={0}>
                  <Grid container sm={12} item>
                    <FormControlLabel
                      style={{
                        width: '100%',
                        border:
                          radioValue == 'PJ'
                            ? '1px solid rgb(0, 102, 158)'
                            : '1px solid #bbb',
                        background: radioValue == 'PJ' ? '#E7F0FF' : '#fff',
                      }}
                      checked={radioValue === 'PJ'}
                      value="PJ"
                      control={<Radio />}
                      label="Fornecedor (Pessoa Jurídica)"
                    />
                  </Grid>
                  <Grid container sm={12} item>
                    <FormControlLabel
                      style={{
                        width: '100%',
                        border:
                          radioValue == 'PF'
                            ? '1px solid rgb(0, 102, 158)'
                            : '1px solid #bbb',
                        background: radioValue == 'PF' ? '#E7F0FF' : '#fff',
                      }}
                      checked={radioValue === 'PF'}
                      value="PF"
                      control={<Radio />}
                      label="Fornecedor (Pessoa Física)"
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
              {radioValue == 'PJ' ? (
                <Controller
                  name="cnpj"
                  control={control}
                  mask="**.***.***/****-**"
                  defaultValue=""
                  rules={{ required: 'CNPJ required' }}
                  render={({ field: { onChange, onBlur, ref } }) => (
                    <InputMask
                      mask="**.***.***/****-**"
                      maskChar={'_'}
                      onBlur={onBlur}
                      onChange={onChange}
                    >
                      {(inputProps) => (
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          {...inputProps}
                          id="cnpj"
                          label="CNPJ"
                          autoFocus
                        />
                      )}
                    </InputMask>
                  )}
                />
              ) : null}

              <Controller
                name="cpf"
                control={control}
                mask="999.999.999-99"
                defaultValue=""
                rules={{ required: 'CPF required' }}
                render={({ field: { onChange, onBlur, ref } }) => (
                  <InputMask
                    mask="999.999.999-99"
                    maskChar={'_'}
                    onBlur={onBlur}
                    onChange={onChange}
                  >
                    {(inputProps) => (
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        {...inputProps}
                        id="cpf"
                        label="CPF do usuário"
                      />
                    )}
                  </InputMask>
                )}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                style={{ backgroundColor: '#00669e' }}
                sx={{ mt: 3, mb: 2 }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  {loading ? (
                    <CircularProgress color={'inherit'} size={25} />
                  ) : (
                    <span>Enviar</span>
                  )}
                </Box>
              </Button>
              <Grid container sm={12} item justifyContent={'space-between'}>
                <Grid item xs={6}></Grid>
                <Grid
                  item
                  xs={6}
                  display={'flex'}
                  justifyContent={'flex-end'}
                  alignItems={'center'}
                >
                  {/* <RouterLink to="/"> */}
                  <span onClick={goToLogin} variant="body2">
                    {'Voltar ao login'}
                  </span>
                  {/* </RouterLink> */}
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
